const instanceStatusAttrs = {
  1: { color: 'grey lighten-2', dark: false },
  2: { color: 'blue', dark: true },
  3: { color: 'green', dark: true },
  4: { color: 'grey darken-1', dark: true }
}

const taskStatusAttrs = {
  1: { color: 'grey lighten-2', dark: false },
  2: { color: 'blue', dark: true },
  3: { color: 'green', dark: true },
  4: { color: 'orange darken-1', dark: true },
  5: { color: 'red', dark: true },
  6: { color: 'grey darken-1', dark: true }
}

export default {
  methods: {
    instanceStatusAttrs (statusId) {
      return instanceStatusAttrs[statusId] || { color: 'grey lighten-2', dark: false }
    },
    taskStatusAttrs (statusId) {
      return taskStatusAttrs[statusId] || { color: 'grey lighten-2', dark: false }
    }
  }
}
